import { Mark, Student } from '@/plugins/api'
import alert from '@/plugins/alert'
import { get, max, orderBy, keyBy } from 'lodash'
import moment from 'moment'
import { getFactorsByFilter } from './utils'
import { generateTeacherWorkbookAndSaveAction, generateSchoolWorkbookAndSaveAction } from './markReports'

const getMaxColForFactors = (totalMarks = 0, defaultColNum = 0) => {
  if (totalMarks >= defaultColNum) return totalMarks + 2
  return defaultColNum
}
const setMaxColForFactors = ({ factors = [], marks = [], students = [] }) => {
  const tmpFactors = keyBy(factors, 'id')
  Object.values(tmpFactors).reduce((_, factor) => {
    const factorMarks = students.reduce((acc, student) => {
      const markNo = marks.filter(m => get(m, 'factor.id') === factor.id && get(m, 'student.id') === student.id).length
      return [...acc, markNo]
    }, [])
    tmpFactors[factor.id] = {
      ...tmpFactors[factor.id],
      maxCol: getMaxColForFactors(max(factorMarks), factor.quantity)
    }
  }, [])
  return tmpFactors
}
const getDateToFetch = () => {
  const dateStart = moment().startOf('day')
  const dateEnd = moment().endOf('day')
  return { dateStart, dateEnd }
}

export default {
  namespaced: true,
  state: {
    marks: [],
    students: [],
    studentMarks: {},
    filterParam: {},
    semesterMaxCol: -1,
    factors: [],
    isClassExtraCurriculum: false,
    excelFactors: [],
    excelData: [],
    excelIsCreated: false,
    excelFileName: ''
  },
  actions: {
    resetExcelImportState({ commit }) {
      commit('changeState', {
        excelFactors: [],
        excelData: [],
        excelIsCreated: false,
        excelFileName: ''
      })
    },
    saveExcelImportPreview({ commit }, params) {
      commit('changeState', params)
    },
    async saveImportMarks(_, data) {
      try {
        const mark = await Mark.createMultiple(data)
        return mark
      } catch (e) {
        alert.error(e)
      }
    },
    async fetchMarks({ commit, state }, options = {}) {
      try {
        const params = {}
        if (options.semester) {
          if (typeof options.semester === 'object') {
            if (options.semester.id) params.semester = options.semester.id
            else if (options.semester._id) params.semester = options.semester._id
          } else {
            params.semester = options.semester
          }
        }
        if (options.class) {
          if (typeof options.class === 'object') {
            if (options.class.id) params.class = options.class.id
            else if (options.class._id) params.class = options.class._id
          } else {
            params.class = options.class
          }
        }
        if (options.subject) {
          if (typeof options.subject === 'object') {
            if (options.subject.id) params.subject = options.subject.id
            else if (options.subject._id) params.subject = options.subject._id
          } else {
            params.subject = options.subject
          }
        }

        if (options.isReport === true) params.isReport = true

        if (options.limit !== undefined && options.limit !== null) params._limit = options.limit
        else params._limit = -1
        params._sort = options._sort || 'date:ASC'

        const marksResp = await Mark.fetch(params)
        let marksArr = []
        if (Array.isArray(marksResp)) marksArr = marksResp
        else if (marksResp && Array.isArray(marksResp.data)) marksArr = marksResp.data
        else marksArr = marksResp ? marksResp.data || [] : []

        commit('setMarks', marksArr)

        if (options.class && options.subject) {
          try {
            const { dateStart, dateEnd } = getDateToFetch()
            let factors = []
            if (options.subject && options.subject.factors) {
              factors = getFactorsByFilter(
                options.subject.factors,
                options.semester && options.semester.type ? options.semester.type : null
              )
            } else {
              factors = []
            }

            const isClassExtraCurriculum = get(options, 'class.type') === 'extraCurriculum'
            let classesDictForEC = {}
            if (isClassExtraCurriculum) classesDictForEC = get(options, 'class.metadata.coreOrders', {})

            let tmp = get(options, 'class.students', [])
            if (!Array.isArray(tmp) || tmp.length === 0) {
              tmp = await Student.fetch({ currentClass: get(options, 'class.id') })
            }

            let students = (Array.isArray(tmp) ? tmp : [])
              .filter(s => s && s.status === 'active')
              .map(s => {
                const fn = s.formatedName ? s.formatedName.split(' ').shift() : ''
                const ln = s.formatedName ? s.formatedName.replace(`${fn} `, '') : ''
                return { ...s, fn, ln }
              })
              .sort((a, b) => {
                const collator = new Intl.Collator('vi')
                const r = collator.compare(a.fn, b.fn)
                return r !== 0 ? r : collator.compare(a.ln, b.ln)
              })

            if (isClassExtraCurriculum) {
              students = orderBy(students, ['currentClass', 'asc'])
            }

            // Dùng state.marks thay vì commit.state và tránh trùng tên biến
            const currentMarks = JSON.parse(JSON.stringify(state ? state.marks : []))
            const factorsMap = setMaxColForFactors({ factors, marks: currentMarks, students })
            const factorsInArr = orderBy(Object.values(factorsMap), ['multiply'])

            const studentMarks = students.map(student => {
              let tmpMarks = []
              factorsInArr.forEach(factor => {
                let tmpM = marksArr
                  .filter(m => get(m, 'student.id') === student.id && get(m, 'factor.id') === factor.id)
                  .map(m => ({
                    ...m,
                    rawValue: m.value,
                    markInDate: m.date === dateStart.toISOString() || moment(m.date).isBetween(dateStart, dateEnd)
                  }))
                tmpM = Array.from(Array(factor.maxCol).keys()).map(
                  index => tmpM[index] || { index, value: undefined, markInDate: true, factor }
                )
                tmpMarks = tmpMarks.concat(tmpM)
              })
              if (isClassExtraCurriculum) student.currentClassTitle = classesDictForEC[student.currentClass]
              return { student, marks: tmpMarks }
            })

            commit('changeState', {
              studentMarks,
              filterParam: options,
              factors: factorsMap,
              isClassExtraCurriculum
            })
          } catch (errInner) {
            console.error('enhanced fetchMarks processing failed:', errInner)
          }
        }

        return marksArr
      } catch (error) {
        console.error('fetchMarks error', error)
        alert.error(error)
        return []
      }
    },

    async generateTeacherWorkbookAndSave(ctx, payload) {
      try {
        return await generateTeacherWorkbookAndSaveAction(ctx, payload)
      } catch (err) {
        alert.error('Lỗi khi xuất báo cáo (theo giáo viên)')
        throw err
      }
    },
    async generateSchoolWorkbookAndSave(ctx, payload) {
      try {
        return await generateSchoolWorkbookAndSaveAction(ctx, payload)
      } catch (err) {
        alert.error('Lỗi khi xuất báo cáo (toàn trường)')
        throw err
      }
    }
  },

  mutations: {
    setMarks(state, marks) {
      state.marks = marks
    },
    setStudents(state, students) {
      state.students = students
    },
    updateMark(state, mark) {},
    createMark(state, mark) {},
    removeMark(state, id) {},
    setFactor(state, factor) {
      state.factor = factor
    },
    changeState(state, payload) {
      Object.keys(payload).forEach(k => {
        state[k] = payload[k]
      })
    }
  },

  getters: {
    studentMarks: state => {
      return Object.values(state.studentMarks)
    }
  }
}
